/**
 * Reducer for any errors that might need to appear
 */

import { ActionTypes as types, SEND_MONEY_ERRORS, REQUEST_MONEY_ERRORS } from '../constants'

function getInitialState() {
  return {
    overpanel: undefined,
    page: undefined,
    error: undefined,
    nextPageError: undefined,
  }
}

const hideServiceMessagesCodes = [
  'requesterAccountRestricted',
  'blockedSend',
  'blockedRequest',
  'errorTransactionDeclinedNegativeBalance',
  SEND_MONEY_ERRORS.COUNTRY_DISALLOWED,
  SEND_MONEY_ERRORS.SHOP_ITEM_UNAVAILABLE,
  SEND_MONEY_ERRORS.INSTRUMENT_DEBIT_FAILED,
  SEND_MONEY_ERRORS.GROUPS_SENDER_CANNOT_SEND_PERSONAL_PAYMENT,
  SEND_MONEY_ERRORS.GROUP_CONTRIBUTION_LIMIT_EXCEEDED,
  REQUEST_MONEY_ERRORS.REQUESTEE_SEARCH_PREFERENCES_NOT_ENABLED
]

export default function errors(state = getInitialState(), action) {
  switch (action.type) {
    case types.ERROR.SHOW_ERROR_OVERPANEL:
      const error = action.data.error
      const hideServiceMessage = error && hideServiceMessagesCodes.includes(error.code)
      return {
        ...state,
        overpanel: {
          ...error,
          hideServiceMessage,
        },
        error,
      }
    // closing the error overpanel should clear out the error
    case types.OVERPANELS.TOGGLE_ERROR_OVERPANEL:
      return {
        ...state,
        overpanel: !action.data.show ? undefined : state.overpanel,
      }
    // any route change should clear out the error
    case types.ROUTER.LOCATION_CHANGE:
      return {
        ...state,
        overpanel: undefined,
        page: state.nextPageError,
        nextPageError: undefined,
      }
    case types.ERROR.SHOW_ERROR_PAGE:
      return {
        ...state,
        page: action.data.error,
      }

    case types.ERROR.SHOW_ERROR_NEXT_PAGE:
      return {
        ...state,
        nextPageError: action.data.error,
      }

    default:
      return state
  }
}
